import { TaskPlannerSchemaTypes } from "@bfc-software/api-schemas";
import { logger } from "@bfc-software/app-toolbox";
import { QueryClient } from "@tanstack/react-query";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";

const fetchClient = () => {
  const token =
    localStorage.getItem("aaaToken") || localStorage.getItem("token");

  const baseUrl = `${getEnv().tpsServiceBase}/taskPlanner/v1`;

  logger.info(`Building task planner api client against '${baseUrl}'`);

  return createFetchClient<TaskPlannerSchemaTypes.paths>({
    baseUrl,
    credentials: "include",
    headers: {
      "X-ACCESS-KEY": getEnv().authAccessKey,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

export const apiClient = () => createClient(fetchClient());

/** Raw fetch client for imperative (non-hook) usage */
export const rawFetchClient = () => fetchClient();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
